import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import Markdown from "react-markdown"

import { SmallBlogTeaser, transformLinkUri } from "gatsby-theme-gba"

const SmallBlogTeaserEditable = ({ blok }) => {
  const { file, allFile } = useStaticQuery(graphql`
    query SmallBlogTeaserExampleQuery {
      file(relativePath: { eq: "small-blog-teaser.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      allFile(
        filter: { id: { regex: "/(?:(?:.*)bigPageTeaser)|(?:(?:blog))/" } }
      ) {
        edges {
          node {
            id
            name
            childImageSharp {
              gatsbyImageData(width: 791, quality: 80)
            }
          }
        }
      }
    }
  `)

  let filteredFiles = allFile.edges.filter(function (projectFile) {
    if (!blok.image || !projectFile.node.id.includes(blok.image.substring(1))) {
      return false // skip
    }

    return true
  })

  let imageFile = filteredFiles[0]
    ? getImage(filteredFiles[0].node)
    : blok.image

  const link = blok.link ? `/${blok.link}` : "/home"

  let date = new Date(blok.date).toLocaleDateString("de-DE")

  if (date === "Invalid Date") {
    date = new Date().toLocaleDateString("de-DE")
  }

  return (
    <SmallBlogTeaser
      {...storyblokEditable(blok)}
      key={blok._uid}
      eventDate={date}
      eventImage={imageFile || getImage(file)}
      eventImageAlt={blok.imgAlt}
      eventLink={link}
      linkTarget={blok.linkTarget}
      mode={blok.mode}
      currentLanguage={blok.currentLanguage}
    >
      <Markdown
        transformLinkUri={(uri) => {
          return transformLinkUri(uri, "", blok.currentLanguage)
        }}
      >
        {blok.previewText}
      </Markdown>
    </SmallBlogTeaser>
  )
}

export default SmallBlogTeaserEditable
